export const KEYWORDS = [
    [ 'british', 1520 ], 
    [ 'us', 1505 ],
    [ 'soldier', 1113 ], 
    [ 'war', 1101 ],
    [ 'soldiers', 958 ],
    [ 'you', 858 ], 
    [ 'liberty', 835 ],
    [ 'your', 708 ], 
    [ 'flag', 704 ],
    [ 'red', 546 ], 
    [ 'holding', 543 ],
    [ 'german', 523 ],
    [ 'american', 514 ], 
    [ 'man', 504 ],
    [ 'woman', 498 ], 
    [ 'child', 0],
    [ 'loan', 489 ],
    [ 'cross', 477 ], 
    [ 'background', 477 ],
    [ 'french', 462 ], 
    [ 'german', 0 ],
    [ 'victory', 432 ],
    [ 'buy', 430 ],
    // [ 'two', 427 ], 
    // [ 'men', 427 ],
    // [ 'are', 413 ], 
    [ 'bonds', 381 ],
    [ 'wheat', 379 ], 
    [ 'over', 339 ],
    [ 'his', 315 ],
    [ 'her', 0 ],
    // [ 'up', 315 ],
    // [ 'this', 308 ], 
    // [ 'words', 306 ],
    [ 'under', 300 ]
].map(w => w[0])

export const TOPICS = [
    [ "Propaganda" ],
    [ "Morale and propaganda" ],
    [ "Fund raising" ],
    [ "Recruiting and enlistment" ],
    [ "Relief and volunteer organizations",
        "Relief/volunteer organizations" ],
    [ "Reconstruction" ],
    [ "Liberty bonds" ],
    [ "Conservation/Food production" ],
    [ "War production" ],
    [ "Exhibitions, Films, Publications",
        "Exhibitions & Films" ],
    [ "Women's War Work" ],
    [ "Women in war" ],
    [ "Troop morale" ],
    [ "International relief" ],
    [ "War Savings Stamps" ],
    [ "Tribute to Allies" ],
    [ "Conservation of natural resources",
        "Conservation of resources" ],
    [ "Travel" ],
    [ "Health/Industrial Safety" ],
    [ "Food conservation" ],
    [ "Politics" ],
    [ "Careless talk" ],
    [ "Statue of Liberty (New York, N.Y.)",
        "Statue of Liberty" ],
    [ "Education" ],
    [ "Ethnic groups" ],
    [ "Advertisement" ],
    [ "Uncle Sam (Symbolic character) in art",
        "Uncle Sam in Art" ],
    // [ "advertising" ],
    [ "Celebrities" ],
    [ "Civil defense" ],
    [ "Defense Preparedness" ],
    [ "Proclamations" ],
    [ "Discharging Soldiers" ],
    // [ "Personalities" ],
    [ "Nurses" ],
    [ "Educational" ],
    // [ "Ships" ],
    [ "Liberty Bell" ],
    [ "Industrial safety" ],
    [ "Employment" ],
    [ "New Deal Projects" ],
    [ "Shipbuilding" ],
    // [ "Energy conservation" ],
    // [ "Transportation" ],
    [ "Prisoners of war" ]
]